module.exports = __webpack_public_path__ + "img/niias_logo.c45e8355.png";